import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';
import { AuthService } from '@app/features/auth/auth.service';

@Component({
  selector: 'app-login-required',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './login-required.component.html',
  imports: [MatDialogModule, TranslateModule, MatButton],
})
export class LoginRequiredComponent {
  #authService = inject(AuthService);
  isLoading = false;

  constructor(dialogRef: MatDialogRef<LoginRequiredComponent>) {
    dialogRef.updateSize('400px');
    dialogRef.disableClose = true;
  }

  async onLogout() {
    this.isLoading = true;
    await this.#authService.logout(true);
  }
}
